import { ORDER_STATUS_SERVER } from "../../UnifiedControlPlane.constants";

const SingleOrderDetailsExpanded = ({ displayAssingments }) => {
  return (
    <table className="expandedSubOrderTable">
      <tr className="expandedSubOrderTableHeaderRow">
        <th style={{ textAlign: "left", paddingLeft: "50px" }}>TASK</th>
        <th>TRIGGER STATUS</th>
        <th>GEO-TRIGGER</th>
        <th>ACTION</th>
      </tr>
      {displayAssingments.map((item) => (
        <tr className="expandedSubOrderTableSpikeItemRow">
          <td>
            <div style={{ display: 'flex' }}>
              <button className="orderProgressDivPendingBtn" style={{ float: "left", padding: "0px" }}>
                {item.status === ORDER_STATUS_SERVER.COMPLETE && <img className="pauseIcon noTop" src={require("../../assets/raw/GreenTickSmallIcon.svg").default} alt="complete" />}
                {item.status === ORDER_STATUS_SERVER.WAITING && <img className="pauseIcon noTop rotationIcon" src={require("../../assets/raw/PendingIcon.svg").default} alt="waiting" />}
                {item.status === ORDER_STATUS_SERVER.PENDING && <img className="pauseIcon noTop" src={require("../../assets/raw/WaitingTimeIcon.svg").default} alt="pending" />}
                {item.status === ORDER_STATUS_SERVER.WARNING && <img className="pauseIcon noTop" src={require("../../assets/raw/OrangeWarningIcon.svg").default} alt="warning" />}
              </button>
              <div className="orderTitleMainDiv" style={{ alignContent: 'center' }}>
                <div className="orderTitleDiv">
                  <div className="subOrderTitleName white">{item?.satellite?.name}&ensp;|&ensp;</div>
                  <div className="subOrderTitleName grey"> {item?.name}</div>
                </div>
                {/* <div className="orderTitleDiv">
                  {item.componentImg != "" && <img className="subOrderImg" src={item.componentImg} />}
                  <div className="subOrderTitleName grey">{item.component}&ensp;|&ensp;</div>
                  <div className="subOrderTitleName yellow">{item.type}</div>
                </div> */}
              </div>
            </div>
          </td>
          <td>
            <div className="subOrderTitleName white">{item?.status}</div>
          </td>
          <td>
            <div className="subOrderTitleName yellow">{item?.type}</div>
          </td>
          <td>
            <button className="spikeItemActionBtn">
              <img className="pauseIcon" src={require("../../assets/raw/OpenNewWindowIcon.svg").default} alt="new-window" />
            </button>
          </td>
        </tr>
      ))}
    </table>
  );
};

export default SingleOrderDetailsExpanded;
